import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
import createPersistedState from 'vuex-persistedstate'
export default new Vuex.Store({
	plugins: [
		createPersistedState({
			storage: window.sessionStorage,
		}),
	],
	state: {
		userName: '', // 用户名
		token:"",//令牌
		userInfo:"",//用户信息

	},
	// getters: {
	//   topNavState: state => state.common.topNavState,
	//   leftNavState: state => state.common.leftNavState,
	//   permsList: state => state.common.permsList
	// },
	mutations: {
		update_username(state, params) {
			state.userName = params
		},
		update_token(state, params) {
			state.token = params
		},
		update_userInfo(state, params) {
			state.userInfo = params
		}

	},
	actions: {},
	modules: {}
})
